/* Amazon-style cents for the SUBSCRIPTION BUY BOX.
 *
 * Those prices ("$2.99", "$2.99/ea", the Autoship price beneath it) are rendered by the Appstle
 * app, not by this theme — no snippet, no Liquid, nothing for price-as-money.liquid or the theme's
 * own JS formatters to reach. So every other price on the site raised its cents and the buy box
 * stayed flat (owner 2026-09-04, "still not showing in the buy box").
 *
 * The only lever is to rewrite what the app renders, after it renders, and again whenever it
 * re-renders (variant change, plan change, quick-buy drawer). That is what this does.
 *
 * NOT put in llm-unit-price-label.js, which does the same kind of Appstle post-processing: that
 * file is referenced by no template and has never run. Reviving it would have silently switched its
 * "/item" -> "/ea" relabel back on as a side effect, which is a separate decision.
 */
(function () {
  /* The buy-box AMOUNT only. Its two unit-price lines (.appstle_one_time_unit_price /
     .appstle_selling_plan_unit_price, "$2.99/ea") were included at first and pulled back out —
     superscript is for primary prices, and unit prices render at 13px where the cents landed at
     ~8px (owner 2026-09-05). */
  var SEL = '.appstle_subscription_amount';

  function apply() {
    if (!window.llmMoney) return;
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      /* Idempotence matters more than usual here: the observer below watches the subtree we are
         writing into, so without this check every write would trigger another pass forever. */
      if (el.querySelector('sup.llm-cents')) continue;
      var txt = el.textContent.trim();
      if (!txt) continue;
      var html = window.llmMoney.cents(txt);
      // No trailing "<separator><two digits>" — e.g. "Free", or "$2.99 every 2 months", where the
      // trailing digits mean the amount is not at the end. Leave those exactly as the app wrote them.
      if (html.indexOf('<sup') === -1) continue;
      el.innerHTML = html;
    }
  }

  /* MICROTASK, not setTimeout and not requestAnimationFrame.

     This was setTimeout(…, 50), which meant Appstle painted the flat "$34.99" and the superscript
     arrived up to 50ms later — a visible flash of full-size cents every time the option changed
     (owner 2026-09-06: "you can see the large cents before they are converted"). A microtask is
     still batched to one pass per burst, but it runs BEFORE the browser paints, so the flat form is
     never on screen.

     Not rAF: it does not fire at all in a background tab, so a product page opened in one
     (middle-click from a collection, restored session) would sit with flat cents until focused —
     verified previously. Microtasks have no such dependency. */
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var run = function () { scheduled = false; apply(); };
    if (typeof queueMicrotask === 'function') queueMicrotask(run);
    else Promise.resolve().then(run);
  }

  function start() {
    apply();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
